import * as types from "@/redux/ActionTypes";
import { MessageState } from "@/types/RootState";

// Action interfaces
interface MessageAction {
  type: typeof types.MESSAGE;
  data: MessageState;
}

interface DefaultAction {
  type: string;
  data?: unknown;
}

type Action = MessageAction | DefaultAction;

const initialState: MessageState = {
  type: "",
  message: "",
};

const myReducer = (state: MessageState = initialState, action: Action): MessageState => {
  switch (action.type) {
    case types.MESSAGE:
      return { ...(action as MessageAction).data };
    default:
      return state;
  }
};

export default myReducer;
